import { useTranslation } from 'react-i18next';
import { BridgePanel } from '../BridgePanel/BridgePanel';
import { useClientRenderDelay } from 'utils/hooks/useClientRenderDelay';

export function BridgePageContainer() {
  const { t } = useTranslation('common');
  const csr = useClientRenderDelay();

  return (
    <div className='font-haben flex flex-col items-center px-6 pt-8 max-lg:pt-0'>
      <div className='pb-3 text-3xl font-bold text-white'>{t('BRIDGE')} </div>

      <div className='text-md pb-6 text-center text-white'>
        {t('BRIDGE_DESCRIPTION')}
      </div>
      {csr && <BridgePanel />}
    </div>
  );
}
